import {DepartmentService} from "../resource";

const DepartmentModule = {
	namespaced: true,
	state: {
		datas: [],
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		}
	},
	actions: {
		createData({ commit, state }, data) {
			return DepartmentService.DepartmentCreate(data);
		},

		updateData({ commit, state }, data) {
			return DepartmentService.DepartmentUpdate(data.id,data.payload);
		},

		deleteData({ commit, state }, data) {
			return DepartmentService.DepartmentDelete(data);
		},

		async listData({ commit, state }, data) {
			try
			{
				const response = await DepartmentService.DepartmentList(data);
				commit("SET_DATA", response.data.Data);
			}
			catch (error)
			{
				commit("SET_DATA", []);
			}
		}
	},
	getters: {
		getData(state) {
			return state.datas;
		}
	},
};

export default DepartmentModule;